
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password/recover",
      function () {
        return require("private-next-pages/password/recover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password/recover"])
      });
    }
  